import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  Inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskAnalysisModel } from 'src/app/models/task-analysis.model';
import { ApiService } from 'src/app/shared/api.service';
import { UtilsService } from '../../shared/utils.service';
import { FileModel } from 'src/app/shared/file.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-task-analyses-view',
  templateUrl: './task-analyses-view.component.html',
  styleUrls: ['./task-analyses-view.component.scss']
})
export class TaskAnalysesViewComponent implements OnInit {
  task_analysis: TaskAnalysisModel = new TaskAnalysisModel();

  inline_doc: FileModel = {};

  @ViewChild('fileInput') fileInput: ElementRef;

  files: any = [];

  dialogData: any;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public renderer: Renderer2,
    public utils: UtilsService,
    private api: ApiService,
    @Inject(MAT_DIALOG_DATA) private id: number
  ) {}

  ngOnInit() {
    // get the site id
    this.task_analysis.id = this.id;

    this.api.laravelApiRequest(
      'get',
      `task-analysis/${this.task_analysis.id}`,
      {},
      {},
      (response) => {
        this.task_analysis.apply(response.data);
      }
    );
  }

  onRemove() {
    const singular = this.utils.getLangTerm('task_analysis_documents.singular', 'Task Analysis Document');
    this.utils.showModal(
      `Remove ${singular}`,
      `Are you sure you want to remove this ${singular}?`,
      () => {
        this.api.laravelApiRequest(
          'delete',
          'task-analysis/' + this.task_analysis.id,
          {},
          {},
          () => {
            this.utils.showToast(`The ${singular} was removed.`);
            this.router.navigate(['task-analysis']);
          },
          (error) => {
            this.utils.showModal('Error', error.message);
          }
        );
      }
    );
  }
}
